export const ENCRYPTION_CHUNK_SIZE = 4 * 1024 * 1024;

export enum PasswordStrength {
    WEAK,
    MODERATE,
    STRONG,
}
